import React, { FC, ReactNode } from "react";
import { Heading, Stack } from "@chakra-ui/react";

import Button from "components/Chakra/Button";
import {
  useModal,
  useCreateModal,
  InitialUseCreateModalType,
} from "../ModalsProvider";

type InfoModalProps = {
  title: string;
  content: ReactNode;
  confirmButton?: string;
};

const InfoModal: React.FC<InfoModalProps> = ({
  content,
  title,
  confirmButton,
}) => {
  const { closeModal } = useModal("infoModal");

  return (
    <>
      <Heading as="h3" mb={2}>
        {title}
      </Heading>
      <Stack>
        <Stack>{content}</Stack>
      </Stack>
      {confirmButton && (
        <Button mt={7} w="full" onClick={() => closeModal()}>
          {confirmButton}
        </Button>
      )}
    </>
  );
};

export const useInfoModal: InitialUseCreateModalType<InfoModalProps> = () =>
  useCreateModal("infoModal", InfoModal as FC, null, null, {
    size: "md",
  });
